<template>
  <div class="equipment">
    <div class="equipment_nav">
      <navbar
        title="设备认领"
        :lefticon="lefticon"
        :lefticonheight="1.8"
        :lefticonwidth="1.8"
        :fontweight="700"
        :fontsize="'1.8rem'"
        @goback="goBack(false)"
      />
    </div>
    <van-row class="box">
      <img :src="image" />
    </van-row>
    <van-row class="equipment_footer">
      <van-col span="24">
        <btn
          :btntext="'去认领'"
          :btnwidth="'35.1rem'"
          :height="'4.4rem'"
          :bgcolor="'#4697FF'"
          :borderradius="'2.5rem'"
          :btncolor="'#fff'"
          :fontsize="'1.7rem'"
          @btnClick="toSelect"
        />
      </van-col>
    </van-row>
  </div>
</template>
<script>
import navbar from "../accountAgent/components/nav-bar.vue";
import btn from "../accountAgent/components/button.vue";
export default {
  components: {
    navbar,
    btn,
  },
  data() {
    return {
      lefticon: require("@/assets/accountAgent/common/back.png"),
      image: "",
    };
  },
  created() {
    if (this.$route.query.token) {
      this.$api.setToken(this.$route.query.token);
    }
    this.getInfo();
  },
  mounted() {
    document.documentElement.style.setProperty(
      "font-size",
      (document.body.clientWidth / 375) * 10 + "px"
    );
  },
  methods: {
    goBack() {
      this.params("", "", "goBack");
    },
    getInfo() {
      this.$api.get("/ongoods/index/equipment/get/home/page").then((res) => {
        this.image = res.image;
      });
    },
    toSelect() {
      this.$router.push("/equipment/select");
    },
  },
};
</script>
<style>
html {
  font-size: calc(var(--sizeScale2) * 10px);
}
</style>
<style lang="less" scoped>
.equipment {
  height: 100%;
  box-sizing: border-box;
  background: #e3e3e3;

  .equipment_nav {
    position: fixed;
    top: 0;
    width: 100%;
    padding-top: 4.4rem;
    background-color: #fff;
    z-index: 3;
  }

  .box {
    padding: 8.8rem 0 0;
    box-sizing: border-box;
    height: 100%;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;

    img {
      width: 100%;
      height: auto;
      display: block;
    }
  }

  .equipment_footer {
    position: fixed;
    bottom: 3.4rem;
    left: 0;
    width: 100%;
    padding-left: 1.2rem;
  }
}
</style>


